import React, { useState } from "react";
import MainToolbar from "./MainToolbar";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import SaveIcon from "@material-ui/icons/Save";
import { green } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import { showLoaderStateActions } from "./store";
import { useDispatch, useSelector } from "react-redux";
import SuccessDialog from "./SuccessSweetAlertDialog";
import {filterErrorMessage} from "./common/stringUtils";

import t from "./common/localization";
import { useEffectAsync } from "./reactHelper";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },

  buttons: {
    size: "small",
    justifyContent: "space-evenly",
    "& > *": {
      margin: "10px",
      top: "auto",
      left: "75%",
    },
  },
}));

const EditItemView = ({ children, endpoint, item, setItem, operatingUser }) => {
  const history = useHistory();
  const classes = useStyles();
  const { id, deviceId } = useParams();
  const dispatch = useDispatch();
  const [successDialogShown, setSuccessDialogShown] = useState(false);
  const [alertProps, setAlertProps] = useState({
    success: true,
    title: "Success",
  });

  const handleRemoveResult = () => {
    // history.goBack();
    setSuccessDialogShown(false);
  };

  const closeDialogShown = () => {
    setSuccessDialogShown(false);
  };

  useEffectAsync(async () => {
    if (id && id !== "null") {
      dispatch(showLoaderStateActions.addState(true));
      const response = await fetch(`/api/${endpoint}/${id}`);
      dispatch(showLoaderStateActions.addState(false));

      if (response.ok) {
        setItem(await response.json());
      }
    } else {
      if (endpoint && endpoint === "users") {
        const user = {};
        user.attributes = {};

        user.limitCommands = true;
        user.deviceReadonly = true;
        user.phone = operatingUser.phone;
        user.prepaid = operatingUser.prepaid;
        user.latitude = operatingUser.latitude;
        user.longitude = operatingUser.longitude;
        user.attributes.speedUnit = operatingUser.attributes.speedUnit;
        user.attributes.distanceUnit = operatingUser.attributes.distanceUnit;
        user.attributes.volumeUnit = operatingUser.attributes.volumeUnit;
        user.attributes.timezone = operatingUser.attributes.timezone;
        user.attributes.speedUnit = operatingUser.attributes.speedUnit;
        setItem(user);
      } else if (endpoint === "devices") {
        const device = {};
        device.attributes = {};
        device.prepaid = operatingUser.prepaid;
        device.model = "Common";
        device.category = "car";
        device.attributes.remarks = "";
        device.attributes.driverName = "";
        device.attributes.apn = "";
        device.attributes.sim = "";

        setItem(device);
      } else if (endpoint && endpoint === "vendors") {
        const vendors = {};
        vendors.attributes = {};
        vendors.attributes.androidAppName = "";
        vendors.attributes.androidPackage = "";
        vendors.attributes.androidFcmKey = "";
        vendors.attributes.androidPlay = false;
        vendors.attributes.androidMinVersion = 0;
        vendors.attributes.mappedUser = 0;
        vendors.attributes.androidCurrentVersion = 0;
        vendors.attributes.androidUpdatePush = false;
        vendors.attributes.androidUpdateFeatures = "";
        vendors.attributes.androidUpdateDate = "";

        setItem(vendors);
      } else if (endpoint && endpoint === "deviceModels") {
               const deviceModels = {};
               deviceModels.attributes = {};
               deviceModels.attributes.setTimezone = "";
               deviceModels.attributes.apnCmd = "";
               deviceModels.attributes.serverCmd = "";
               deviceModels.attributes.paramCmd = "";
               deviceModels.attributes.statusCmd = "";
               deviceModels.attributes.engineResume = "";
               deviceModels.attributes.engineStop = "";

               setItem(deviceModels);
             } else {
        setItem({});
      }
    }
  }, [id]);

  const showComplusionError = (message) => {
    setAlertProps({ warning: true, title: "Required", message: message });
    setSuccessDialogShown(true);
  };

  const handleSave = async () => {
    if (endpoint) {
      if (endpoint === "users") {
        if (!item.name) {
          showComplusionError("Name is compulsory");
          return false;
        }
        if (!item.username) {
          showComplusionError("Username is compulsory");
          return false;
        }
        if (!item.expirationTime) {
          showComplusionError("Expiration time is compulsory");
          return false;
        }
        if (!item.id && !item.password) {
          showComplusionError("Password is compulsory");
          return false;
        }
        // if(!item.deviceLimit){
        //    showComplusionError("Device limit is compulsory");
        //   return false;
        // }
        // if(!item.userLimit){
        //    showComplusionError("User limit is compulsory");
        //   return false;
        // }
      } else if (endpoint === "devices") {
        if (!item.name) {
          showComplusionError("Name is compulsory");
          return false;
        }
        //  if(!item.uniqueId){
        //    showComplusionError("IMEI is compulsory");
        //   return false;
        // }
        if (!item.prepaid && !item.expirationTime) {
          showComplusionError("Expiration time is compulsory");
          return false;
        }
        if (!item.phone) {
          showComplusionError("SIM Number is compulsory");
          return false;
        }
        if (!item.model) {
          showComplusionError("Model is compulsory");
          return false;
        }
        if (!item.category) {
          showComplusionError("Category is compulsory");
          return false;
        }
      } else if (endpoint === "drivers") {
        if (!item.name) {
          showComplusionError("Name is compulsory");
          return false;
        }
        if (!item.uniqueId) {
          showComplusionError("Unique name is compulsory");
          return false;
        }
      } else if (endpoint === "vendors") {
        if (!item.name) {
          showComplusionError("Name is compulsory");
          return false;
        }
        if (!item.helpline) {
          showComplusionError("Helpline is compulsory");
          return false;
        }
        if (!item.address) {
          showComplusionError("Address is compulsory");
          return false;
        }
        if (!item.email) {
          showComplusionError("Email is compulsory");
          return false;
        }
      } else if (endpoint === "deviceModels") {
        if (!item.name) {
          showComplusionError("Name is compulsory");
          return false;
        }
        if (!item.protocol) {
          showComplusionError("Protocol is compulsory");
          return false;
        }
        if (!item.port) {
          showComplusionError("port is compulsory");
          return false;
        }
      }
    }

    let url = `/api/${endpoint}`;
    if (id && id !== "null") {
      url += `/${id}`;
    }
    dispatch(showLoaderStateActions.addState(true));
    const response = await fetch(url, {
      method: !id || id === "null" ? "POST" : "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(item),
    });
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const alertObj = {
        success: true,
        title: "Success",
        message: "Created Successfully?",
      };
      const json = await response.json();

      if (deviceId && endpoint === "users") {
        const apiBody = {
          userId: json.id,
          deviceId,
        };
        alertObj.message = `User Created and device attached Successfully !!`;
        const permissionRes = await fetch(`/api/permissions`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(apiBody),
        });
        history.push("/user");
      }
      if (endpoint === "devices") {
        alertObj.customButtons = (
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push(`/user/null/${json.id}`)}
              style={{ marginRight: "15px" }}
            >
              Add User
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={closeDialogShown}
            >
              OK
            </Button>
          </>
        );
      }

      setAlertProps(alertObj);
      setSuccessDialogShown(true);
    } else {
      const errorMessage = response && (await response.text());
      setAlertProps({
        error: true,
        title: "Error",
        message: filterErrorMessage(errorMessage),
      });
      setSuccessDialogShown(true);
    }
  };

  return (
    <>
      <MainToolbar />
      <Container maxWidth="xl" className={classes.container}>
        {children}
        <FormControl fullWidth margin="normal">
          <div className={classes.buttons}>
            <Button
              type="button"
              color="primary"
              variant="contained"
              onClick={() => history.goBack()}
            >
              {t("sharedCancel")}
            </Button>
            <Button
              type="button"
              color="primary"
              //color={ (!item.name || !item.uniqueId) ? 'default' : 'primary' }
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={handleSave}
            >
              {t("sharedSave")}
            </Button>
          </div>
        </FormControl>
        <SuccessDialog
          open={successDialogShown}
          alertProps={alertProps}
          closeDialogShown={closeDialogShown}
          onResult={handleRemoveResult}
        />
      </Container>
    </>
  );
};

export default EditItemView;